import {
	type IFlagsmithFeature,
	useFlags,
	useFlagsmith,
	useFlagsmithLoading,
} from "flagsmith/react";

const FLAG = "hide_pm_close_tabs";

/**
 * The release switch for the Close Tracker inside Project Management: one tab
 * bar on `/workflow` and one sidebar group. True = hidden: today's separate
 * Close Tracker page and sidebar group.
 *
 * It fails closed. The merge shows ONLY when Flagsmith's own flag set holds
 * the key with `enabled: false`. `useFlags` cannot tell that apart from a key
 * Flagsmith never sent: it answers `{ enabled: false }` for any key asked of
 * it, and a server answer replaces the local defaults outright. So presence is
 * read from `getAllFlags()`, and a key that is absent (the flag not created in
 * this environment yet, or deleted), a failed fetch (the `index.tsx` default
 * is `enabled: true`) and no answer yet all count as hidden.
 */
export function useHidePmCloseTabs(): boolean {
	// Two subscriptions, for the two ways the answer can change. `useFlags`
	// re-renders when the flag's value flips. It does not when a key appears
	// or goes away while it reads `enabled: false` both times (a stale cached
	// "off" that the server's answer no longer holds), so the loading state,
	// which changes every time a set of flags lands, is followed as well.
	useFlags([FLAG]);
	useFlagsmithLoading();
	const held = useFlagsmith().getAllFlags() as
		| Record<string, IFlagsmithFeature | undefined>
		| null
		| undefined;
	const flag = held?.[FLAG];
	return !(flag && flag.enabled === false);
}
